import Helper from './Helper';

class Sidenav {
  constructor(config = {}) {
    const {
      containerSelector,
      anchorTextSelector,
      breakpoint
    } = config;
    this.containers = document.querySelectorAll(containerSelector);
    this.anchorTextSelector = anchorTextSelector || '.ns-anchor-container__anchor-text';
    this.breakpoint = breakpoint || 992;
    this.sidenav = document.querySelector('.sidenav');
    this.body = document.querySelector("body");
    this.buttonScrollToIndex = -1;

    this.containersArray = Array.prototype.slice.call(this.containers);
    this.currentScreenWidth = window.innerWidth;

    if (!!this.sidenav) {
      if (this.containersArray.length > 1) {
        this.generateSideNav();
      }
    }
  }

  generateSideNav() {
    let html = '';
    let index = 0;
    let nosn = false;
    html += '<div class="sidenav__content-inner">';
    html += '<div class="sidenav__dots">';
    this.containersArray.forEach(d => {
      d.dataset.index = index;
      d.id = index;
      let titlesText = d.querySelector(this.anchorTextSelector) ? d.querySelector(this.anchorTextSelector).innerHTML : '';
      if(titlesText != ''){
        html += '<a class="sidenav__link" href="#' + index + '"  data-index="'+ index +'"><span class="sidenav__text">' + titlesText + '</span></a>';
        index++;
      } else {
        nosn = true;
      }
    });
    html += '</div>';
    html += '</div>';

    if(!nosn) {
      this.sidenav.innerHTML = html;

      this.sideNavLinks = document.querySelectorAll('.sidenav__link');
      this.sideNavLinksArray = Array.prototype.slice.call(this.sideNavLinks);

      this.sideNavDots = document.querySelector('.sidenav__dots');

      this.setLinkActive(parseInt(this.getIndex(), 10));

      this.bindLinks();
      this.scrollSpy();
    }

    this.addArrowLinks();
  }

  bindLinks() {
    this.sideNavLinksArray.forEach(el => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        let goToIndex = this.containersArray[parseInt(el.getAttribute("href").replace('#', ''))].dataset.index;
        Helper.addClass(this.body, 'stop-scrollspy');
        this.removeLinkActive(parseInt(this.getIndex(), 10));
        this.buttonScrollToIndex = goToIndex;
        this.setLinkActive(goToIndex);

        if ( goToIndex > 0 ) {
          this.scrollTo(this.containersArray[parseInt(el.getAttribute("href").replace('#', ''))], 40, 50);
        } else {
          this.scrollTo(this.containersArray[parseInt(el.getAttribute("href").replace('#', ''))], 90, 150);
        }
      });
    });
  }

  addArrowLinks() {
    let containersCount = this.containersArray.length;
    this.containersArray.forEach((c, index) => {
      if (index + 1 < containersCount) {
        let arrow = c.querySelector(".ns-anchor-container__arrow");
        let arrowText = c.querySelector(".ns-anchor-container__next-chapter");
        let nextTitlesText = this.containersArray[index+1].querySelector(this.anchorTextSelector) ? this.containersArray[index+1].querySelector(this.anchorTextSelector).innerHTML : '';

        if(arrow){
          arrow.dataset.scrollTo = index+1;
          if(nextTitlesText != ''){
            arrowText.innerHTML = nextTitlesText;
          }

          arrow.addEventListener("click", (e) => {
            e.preventDefault();
            this.scrollTo(this.containersArray[parseInt(arrow.dataset.scrollTo)], 40, 50);
          });
        }
      }
    });
  }

  scrollTo(element, mobileTopOffset, desktopTopOffset) {
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: Helper.getRealOffsetTop(element) - (window.innerWidth < 992 ? mobileTopOffset : desktopTopOffset)
    });
  }

  scrollSpy() {
    let lastIndex = 0;
    let lastScroll = 0;
    const maxIndex = this.sideNavLinksArray.length;
    let index = parseInt(this.getIndex(), 10);

    if(window.location.hash && !isNaN(window.location.hash.substring(1))) {
      index = window.location.hash.substring(1);
    }

    this.setLinkActive(index);

    document.addEventListener('scroll', () => {
      if ( this.buttonScrollToIndex === -1 ) {
        if (window.scrollY > lastScroll) {
          //scrolling down
          if (index < maxIndex) {
            if (!!this.containersArray[index + 1] && this.isTopInViewportInclHeader(this.containersArray[index + 1])) {
              index++;
            }
          }
        } else {
          //scrolling up
          if (index > 0) {
            if (!!this.containersArray[index - 1] && this.isBottomInViewport(this.containersArray[index - 1])) {
              index--;
            }
          }
        }
        lastScroll = window.scrollY;
        if (index != lastIndex) {
          if (lastIndex !== false) {
            this.removeLinkActive(lastIndex);
          }
          this.setLinkActive(index);
          lastIndex = index;
        }
      } else {
        if ( this.isInViewportInclHeader(this.containersArray[this.buttonScrollToIndex]) ) {
          Helper.removeClass(this.body, 'stop-scrollspy');
          this.buttonScrollToIndex = -1;
        }
      }
    });
  }

  setLinkActive(index) {
    this.sideNavLinks.forEach(link => link.classList.remove('active'));
    const link = this.sideNavLinksArray[index];
    if (!link.classList.contains('active')) link.classList.add('active');
  }

  removeLinkActive(index) {
    const link = this.sideNavLinksArray[index];
    if (link.classList.contains('active')) link.classList.remove('active');
  }

  getIndex() {
    let index = 0;

    this.containersArray.forEach(t => {
      if (this.isInViewportInclHeader(t)) {
        index = t.dataset.index;
        return index;
      }
    });
    return index;
  }

  isInViewportInclHeader(elem) {
    const bounding = elem.getBoundingClientRect();
    return (
      (bounding.top >= -(window.innerHeight * 0.2) && bounding.top <= 50) &&
      (bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.bottom >= (window.innerHeight * 0.3))
    );
  }

  isTopInViewportInclHeader(elem) {
    const bounding = elem.getBoundingClientRect();
    return (
      (bounding.top >= -(window.innerHeight * 0.2) && bounding.top <= window.innerHeight * 0.5)
    );
  }
  
  isBottomInViewport(elem) {
    const bounding = elem.getBoundingClientRect();
    return (
      (bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.bottom >= (window.innerHeight * 0.5))
    );
  }

}

export default Sidenav;
